<div
  *ngIf="visible"
  class="fullscreen-loader"
  [ngStyle]="{ 'background-color': bgColor || '#ae82c161' }"
>
  <div class="loader"></div>
  <div class="loader-text">
    <p>{{ message }}</p>
  </div>
</div>
